function hasNonAscii(node) {
    if (node == null) return false;
    if (typeof node === 'string') {
        for (let i = 0; i < node.length; i++) {
            if (node.charCodeAt(i) > 127) return true;
        }
        return false;
    }
    if (Array.isArray(node)) {
        for (let i = 0; i < node.length; i++) {
            if (hasNonAscii(node[i])) return true;
        }
        return false;
    }
    if (typeof node === 'object') {
        const keys = Object.keys(node);
        for (let i = 0; i < keys.length; i++) {
            if (hasNonAscii(node[keys[i]])) return true;
        }
        return false;
    }
    return false;
}

export const thermalPrintMixin = {
    methods:{
        // Thermal print functions
		fn_compressBusinessLogo: function(){
			if(!this.$root.ThermalPrintSettings || !this.$root.ThermalPrintSettings.enableThermalPrint){
				this.$router.push({path:"/settings/business/thermalprintsettings"});
				this.showToast('Enable thermal printing option');
				return;
			}

			if(this.$root.CurrentBusiness.businessLogo){
				let self = this;
				let logo = this.$root.CurrentBusiness.businessLogo.replace('data:image/jpeg;base64,', '');
				logo = logo.replace('data:image/png;base64,', '');
				let dataObj = {"thermalLogo":logo};
				this.postData('SaveCompressThermalPrintLogo', dataObj, 
					{
					onSuccess: function(response){
						console.log(response);
						self.fn_prepareData(response);
					},
					onError: function(error){
						console.log(error);
					}
				});
			}
			else{
				this.fn_prepareData();
			}
		},

        fn_prepareData: function(logo){
			if(localStorage.getItem('receipt_data')){
				localStorage.removeItem('receipt_data');
			}

			let packingLabel = null;

			if(this.isPacking){
				packingLabel = this.$root.TransactionSettings.packingLabel ? this.$root.TransactionSettings.packingLabel : 'Pack Qty'
			}

			let bankDetails = null;
			let paymentQR = null;
			// if(this.invoiceFieldsObj && this.invoiceFieldsObj.bankDetails && this.invoiceFieldsObj.bankDetails.status && this.bankDetails && this.bankDetails.data && this.bankDetails.data.content && this.showBankDetails()){
			// 	const result = {};
			// 	const regex = /<p><strong>(.*?)<\/strong>:\s*(.*?)<\/p>/g;

			// 	let match;
			// 	while ((match = regex.exec(this.bankDetails.data.content)) !== null) {
			// 		const key = match[1].trim();
			// 		const value = match[2].trim();
			// 		result[key] = value;
			// 	}

			// 	bankDetails = result ? result : null;
			// }

			// if(this.showBankDetails() && this.invoiceFieldsObj.upiDetails.status && this.paymentQrCodeUrl){
			// 	paymentQR = this.paymentQrCodeUrl.substring(this.paymentQrCodeUrl.indexOf(',')+1);
			// }

			this.$root.thermalPrintInSelectedLanguage ? this.$root.ThermalPrintSettings.printInSelectedLanguage = true : '';
			
			let dataObj = {
				businessData: this.$root.CurrentBusiness,
				invoiceData: this.data,
				transactionDate: this.$root.TransactionSettings.invoiceDateFormat ? this.$moment(this.data.transactionDate).format(this.$root.TransactionSettings.invoiceDateFormat) : this.$moment(this.data.transactionDate).format('DD-MMM-YYYY'),
				// billingAddress: this.billingAddress,
				// shippingAddress:this.shippingAddress,
				// otherFields:this.otherFields,
				// filteredItems:this.filteredItems,
				// roundOffAmount:this.roundOffAmount,
				// summary:this.summary,
				// isMrp:this.isMrp,
				// isHsn:this.isHsn,
				// qtyTotal:this.qtyTotal,
				ThermalPrintSettings:this.$root.ThermalPrintSettings,
				thermalLogo: logo ? logo :null,
				// prescriberDetails: this.prescriberDetails,
				// referrerDetails: this.referrerDetails,
				// hsnSummary:this.hsnSummary,
				// packingLabel:packingLabel,
				// previousBalance:this.$root.TransactionSettings.showPartyBalance && this.data.lastInvoice ? this.$root.numberToLocale(this.fn_previousBalance()) : null,
				currentBalance:this.$root.numberToLocale(this.data.partyDetails.currentBalance),
				showPartyBalance:this.$root.TransactionSettings.showPartyBalance ? true : false,
				appLanguage:this.$root.selectedLanguage,
				imagePrint:false
				// bankDetails:bankDetails,
				// paymentQR:paymentQR
			}

			// this.imagePrint = hasNonAscii(dataObj) || (this.$root.thermalPrintInSelectedLanguage && this.$root.selectedLanguage !== 'en');
			if(this.$root.thermalPrintInSelectedLanguage){
				this.imagePrint = true;
			}
			dataObj.imagePrint = this.imagePrint;
			localStorage.setItem('receipt_data', JSON.stringify(dataObj));
			// this.fn_callBackgroundView();
			this.$root.fn_checkLocationPermission(()=>{
                this.fn_enableBluetooth();
            });
		},

		fn_enableBluetooth: function () {
            let self = this;
            this.getData('EnableBluetooth', null, 
                {
                onSuccess: function(response){
                    console.log(response);
                    self.fn_getDefaultPrinter();
                }, 
                onError: function(error){
                    console.log(error);
                }
            });
        },

		fn_getDefaultPrinter: function () {
			let self = this;
			this.getData('DefaultBluetoothPrinter', null, 
				{
				onSuccess: function(response){
					console.log(response);
					let data = JSON.parse(response);
					if(data.address && data.name){
						self.fn_connectDevice(data);
					}
					else{
						self.$router.push('/settings/bluetoothdevices');
					}
				}, 
				onError: function(error){
					console.log(error);
				}
			});
		},

		fn_connectDevice: function (item) {
			// this.fn_callBackgroundView();
			let self = this;
			let dataObj = {"address":item.address, "name":item.name, "connectForImage":this.imagePrint}
			this.showLoading('Connecting with printer...');
			this.postData('ConnectToBluetoothDevice', dataObj, 
				{
				onSuccess: function(response){
					console.log(response);
					self.hideLoading();
					self.fn_callBackgroundView();
				}, 
				onError: function(error){
					console.log(error);
					self.hideLoading();
					if(error != "Connection was closed manually" && error != "printer is busy"){
						self.$router.push({path:'/settings/bluetoothdevices', query:{'nodevice':1}});
					}
				}
			});
		},

		fn_callBackgroundView: function () {
			let self = this;
			let dataObj = JSON.parse(localStorage.getItem('receipt_data'));
			this.postData('CallBackgroundView', dataObj, 
				{
				onSuccess: function(response){
					console.log(response);
					let postObj = {"eventName":'thermal_print_receipt_payment',"eventData":[{"eventKey":"transaction_number","eventValue":self.data.transactionNumber}]}
					self.$root.fn_postMetrics(postObj);
				}, 
				onError: function(error){
					console.log(error);
				}
			});
		},
    }
}


// WEBPACK FOOTER //
// ./src/components/invoice_templates/receipt_thermal_print_mixin.js